import ApiService, { HttpMethod } from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModelV2 from "../../commons/base/v2/view_model";
import { GeneralDOI, GeneralDOIResponse } from '../models/doi_dashboard_models';

export default class DOIDashboardVM extends ViewModelV2 {

    data: GeneralDOI[] = [];
    isLoading: boolean = true;
    errorMessage: string = "";

    constructor() {
        super();
        this.loadData();

        const refreshDataController = setInterval(() => {
            this.refreshData();
            if (this.errorMessage !== "") {
                clearInterval(refreshDataController)
            }
        }, 1000*60*10);
    }

    loadData() {
        this.emit(() => {
            this.isLoading = true;
        });

        ApiService.fetch<{}, BaseResponse<typeof GeneralDOIResponse>>(
            Endpoints.getGeneralDOI,
            {
                httpMethod: HttpMethod.get,
                onSuccess: (response) => {
                    if (response) {
                        this.emit(() => {
                            this.isLoading = false;
                            this.data = response.data?.slice() ?? [];
                            this.data = this.data.map((data) => {
                                data.itemsLowDOI = data.itemsLowDOI.filter((item) => item.doi >= 0.01)
                                return data;
                            });
                            const storage = window.localStorage;
                            storage.setItem(Endpoints.getGeneralDOI, JSON.stringify(this.data));
                        })
                    }
                },
                onFailure: (error, errorCode) => {
                    this.emit(() => {
                        this.isLoading = false;
                        this.errorMessage = error;
                    });
                }
            }
        );
    }

    /** Fetch DOI without loading screen */
    async refreshData() {
        ApiService.fetch<{}, BaseResponse<typeof GeneralDOIResponse>>(
            Endpoints.getGeneralDOI,
            {
                httpMethod: HttpMethod.get,
                onSuccess: (response) => {
                    if (response) {
                        this.emit(() => {
                            this.data = response.data?.slice() ?? [];
                            this.data = this.data.map((data) => {
                                data.itemsLowDOI = data.itemsLowDOI.filter((item) => item.doi >= 0.01)
                                return data;
                            });
                            const storage = window.localStorage;
                            storage.setItem(Endpoints.getGeneralDOI, JSON.stringify(this.data));
                        })
                    }
                },
                onFailure: (error, errorCode) => {
                    this.emit(() => {
                        this.errorMessage = error;
                    });
                }
            }
        );
    }
}